const calcProfitPercentage = (purchasePrice, saleValue) => {
  try {
    const newPurchasePrice = parseFloat(purchasePrice.replace(/,/g, '.'));
    const newSaleValue = parseFloat(saleValue.replace(/,/g, '.'));
    if (newSaleValue && !isNaN(newPurchasePrice) && !isNaN(newSaleValue)) {
      const result = ((newSaleValue - newPurchasePrice) / newSaleValue) * 100;
      return result.toFixed(1);
    } else {
      return '0.0';
    }
  } catch (err) {
    console.error('Error Calc Profit Percentage: ', err);
    return '0.0';
  }
};

export default calcProfitPercentage;
